import { render, staticRenderFns } from "./JdhLogicalCheckbox.vue?vue&type=template&id=5c681f0b&scoped=true&"
import script from "./JdhLogicalCheckbox.vue?vue&type=script&lang=ts&"
export * from "./JdhLogicalCheckbox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c681f0b",
  null
  
)

export default component.exports